import React from 'react'
import { StyledInput } from './styles';
import clsx from 'clsx';
import { InputBase } from '@mui/material';

type TProps = {
  value: string;
  className?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  onEnter?: () => void;
  disabled?: boolean;
  invalid?: boolean;
  error?: string;
  addon?: JSX.Element;
};

export const Input: React.FC<TProps> = ({value, className, placeholder, invalid, error, disabled, addon, onChange, onEnter}) => {
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.currentTarget.value);
    }
  }

  const onKeyDown = (e: any) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter();
    }
  }

  return (
    <StyledInput className={clsx(className, {disabled})} invalid={!!invalid}>
      <input onKeyDown={onKeyDown} className='custom-input-style' disabled={disabled} value={value} onChange={onInputChange} placeholder={placeholder} />
      {!!invalid && <div className='error'>{error}</div>}
      {!!addon && (
        <div className='addon'>
          {addon}
        </div>
      )}
    </StyledInput>
  )
}
